import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { dropContainerStyles } from './styles';
import { DropOverContainerProps } from './types';
import useDnd from './useDnd';

const DropOverContainer: React.FC<React.PropsWithChildren<DropOverContainerProps>> = (props) => {
  const {
    className,
    dragOnClassName,
    dragOverClassName,
    draggable = false,
    isDropOn = false,
    onDragStart,
    onDragEnd,
    onDrop: onDropCallback,
    children,
    canDrop,
    ...rest
  } = props;

  const { isDragOver, onDragOver, onDrop, onDragLeave } = useDnd({ onDropCallback, canDrop });

  return (
    <Box
      className={cn(
        'relative rounded-4',
        { 'cursor-pointer': draggable },
        { [dropContainerStyles]: isDragOver && isDropOn },
        className,
        { [dragOnClassName ?? '']: isDragOver && isDropOn },
      )}
      draggable={draggable}
      onDragEnd={onDragEnd}
      onDragLeave={onDragLeave}
      onDragOver={onDragOver}
      onDragStart={onDragStart}
      onDrop={onDrop}
      // added restProps for data attributes
      {...rest}>
      {children}
      {isDragOver && !isDropOn ? (
        <Box
          className={cn(
            'drop-line absolute -mt-2 h-2 rounded-full bg-interactive-primary end-0 start-0',
            dragOverClassName,
          )}
        />
      ) : null}
    </Box>
  );
};

export default DropOverContainer;
